import React from 'react'

function attach(props) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="12" viewBox="0 0 10 12">
        
        <path className="a" fill={props.color || "#C4C4C4"} d="M10.609,5.761,9.884,5,6.259,8.805a1.672,1.672,0,0,0,0,2.283,1.487,1.487,0,0,0,2.175,0l4.35-4.567a2.786,2.786,0,0,0,0-3.805,2.477,2.477,0,0,0-3.625,0l-4.567,4.8-.01.01a3.886,3.886,0,0,0,0,5.307,3.456,3.456,0,0,0,5.056,0l.009-.01h0l3.118-3.273-.725-.761L8.922,12.058l-.009.01a2.468,2.468,0,0,1-3.606,0,2.775,2.775,0,0,1,0-3.785l.01-.01h0L9.884,3.477a1.488,1.488,0,0,1,2.175,0,1.674,1.674,0,0,1,0,2.283l-4.35,4.567a.5.5,0,0,1-.725,0,.558.558,0,0,1,0-.761l3.625-3.806Z" transform="translate(-3.535 -1.928)"/>
        </svg>
    )
}

export default attach
